export default function($window) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      jotFormEmbed: '<'
    },
    link: function(scope, element) {
      const iframe = element[0];

      $window.handleIFrameMessage = function(e) {
        if (typeof e.data === 'object') {
          return;
        }

        const args = e.data.split(':');

        switch (args[0]) {
          case 'scrollIntoView':
            iframe.scrollIntoView();
            break;
          case 'setHeight':
            iframe.style.height = args[1] + 'px';
            break;
          case 'collapseErrorPage':
            if (iframe.clientHeight > $window.innerHeight) {
              iframe.style.height = $window.innerHeight + 'px';
            }
            break;
          case 'reloadPage':
            $window.location.reload();
            break;
          case 'loadScript':
            if (!$window.isPermitted(e.origin, ['jotform.com', 'jotform.pro'])) {
              break;
            }
            break;
          case 'exitFullscreen':
            if ($window.document.exitFullscreen) $window.document.exitFullscreen();
            else if ($window.document.mozCancelFullScreen) $window.document.mozCancelFullScreen();
            else if ($window.document.mozCancelFullscreen) $window.document.mozCancelFullScreen();
            else if ($window.document.webkitExitFullscreen) $window.document.webkitExitFullscreen();
            else if ($window.document.msExitFullscreen) $window.document.msExitFullscreen();
            break;
        }

        const isJotForm = e.origin.indexOf('jotform') > -1 ? true : false;

        if (isJotForm && 'contentWindow' in iframe && 'postMessage' in iframe.contentWindow) {
          const urls = { docurl: encodeURIComponent(document.URL), referrer: encodeURIComponent(document.referrer) };
          iframe.contentWindow.postMessage(JSON.stringify({ type: 'urls', value: urls }), '*');
        }
      };

      $window.isPermitted = function(originUrl, whitelisted_domains) {
        const url = document.createElement('a');
        url.href = originUrl;
        const hostname = url.hostname;
        let result = false;

        if (typeof hostname !== 'undefined') {
          whitelisted_domains.forEach(function(element) {
            if (hostname.slice(-1 * element.length - 1) === '.'.concat(element) || hostname === element) {
              result = true;
            }
          });

          return result;
        }
      };

      if ($window.addEventListener) {
        $window.addEventListener('message', $window.handleIFrameMessage, false);
      } else if ($window.attachEvent) {
        $window.attachEvent('onmessage', $window.handleIFrameMessage);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/jotForm/index.js